/** @module OK/cookieBanner */

import * as dom from "OK/utils/dom";
import * as vanilla from "OK/utils/vanilla";

const hideBanner = (element: HTMLElement) => {
    element.classList.add("__hidden");
}
const cookieBanner = {
    activate(element: HTMLElement) {
        const accept: HTMLElement = dom.firstByClass(element, "js-cb_accept")!;
        if (accept) {
            accept.addEventListener("click", () => {
                hideBanner(element);
                /* Эмулируем отправку формы с полным заполнением */
                vanilla.ajax({
                    url: "/dk",
                    data: {
                        "cmd": "PopLayer",
                        "st.layer.cmd": "PopLayerSetupCookies",
                        "st.layer.posted": "set",
                        /* @see CookieCategory */
                        "st.layer.category": ["ESSENTIAL", "FUNCTIONALITY", "PERFORMANCE", "TARGETING"],
                        "button_save_choice": "clickOverGWT"
                    }
                })
            });
        }
        const setup: HTMLElement = dom.firstByClass(element, "js-cb_setup")!;
        if (setup) {
            setup.addEventListener("click", (ev) => {
                const isLink = setup.hasAttribute("href");
                if (isLink) {
                    ev.preventDefault();
                } else {
                    hideBanner(element);
                }
                /* Покажем форму настройки */
                vanilla.ajax({
                    url: isLink ? setup.getAttribute("href")! : setup.getAttribute("data-url")!
                }).then(vanilla.updateBlockModelCallback);
            })
        }
    }
}

export default cookieBanner;
